__turbopack_context__.v({
  "buttonWrapper": "IndiaLearnMoreModal-module__dvgDfW__buttonWrapper",
  "chevronIcon": "IndiaLearnMoreModal-module__dvgDfW__chevronIcon",
  "closeButton": "IndiaLearnMoreModal-module__dvgDfW__closeButton",
  "collapsibleContent": "IndiaLearnMoreModal-module__dvgDfW__collapsibleContent",
  "collapsibleInner": "IndiaLearnMoreModal-module__dvgDfW__collapsibleInner",
  "descriptionSection": "IndiaLearnMoreModal-module__dvgDfW__descriptionSection",
  "descriptionText": "IndiaLearnMoreModal-module__dvgDfW__descriptionText",
  "detailItem": "IndiaLearnMoreModal-module__dvgDfW__detailItem",
  "detailItemDescription": "IndiaLearnMoreModal-module__dvgDfW__detailItemDescription",
  "detailItemTitle": "IndiaLearnMoreModal-module__dvgDfW__detailItemTitle",
  "detailsList": "IndiaLearnMoreModal-module__dvgDfW__detailsList",
  "divider": "IndiaLearnMoreModal-module__dvgDfW__divider",
  "footerButton": "IndiaLearnMoreModal-module__dvgDfW__footerButton",
  "footerButtonLabel": "IndiaLearnMoreModal-module__dvgDfW__footerButtonLabel",
  "headerCurrentPrice": "IndiaLearnMoreModal-module__dvgDfW__headerCurrentPrice",
  "headerInfo": "IndiaLearnMoreModal-module__dvgDfW__headerInfo",
  "headerOriginalPrice": "IndiaLearnMoreModal-module__dvgDfW__headerOriginalPrice",
  "headerPerMonth": "IndiaLearnMoreModal-module__dvgDfW__headerPerMonth",
  "headerPriceRow": "IndiaLearnMoreModal-module__dvgDfW__headerPriceRow",
  "headerSection": "IndiaLearnMoreModal-module__dvgDfW__headerSection",
  "modalContainer": "IndiaLearnMoreModal-module__dvgDfW__modalContainer",
  "modalContent": "IndiaLearnMoreModal-module__dvgDfW__modalContent",
  "planName": "IndiaLearnMoreModal-module__dvgDfW__planName",
  "sectionHeader": "IndiaLearnMoreModal-module__dvgDfW__sectionHeader",
  "sectionTitle": "IndiaLearnMoreModal-module__dvgDfW__sectionTitle",
  "stickyFooter": "IndiaLearnMoreModal-module__dvgDfW__stickyFooter",
  "thumbnailContainer": "IndiaLearnMoreModal-module__dvgDfW__thumbnailContainer",
  "tooltip": "IndiaLearnMoreModal-module__dvgDfW__tooltip",
});
